import * as Apis from '../../utils/apisRequest'


export default {

    //获取优惠券
    //https://apis.aigupiao.com/Coupon/term_list/?appversion=11.7.0&u_id=44324
    async Coupon(opt){
        return await Apis.get({
            url:'/Coupon/term_list/',
            params: {
                ...opt
            }
        })
    },
}
